<template lang="pug">
    include ../../../media/pug/mixins.pug
    +b.SECTION.modal-content
        +e.P.text._paragraph._center(v-html="sessionText")
        +e.UL.list._vertical._center._top(v-if="isSessionStatus !== 'fatal'")
            +e.LI.item._with_margin(v-on:click="$store.dispatch('closeModal')")
                +e.ROUTER-LINK.btn.btn._size_md._theme_transp._full(
                    v-bind:to="{ name: 'Enter', params: { ...$route.params }, query: { ...$route.query} }"
                ) {{ $t('TO_MAIN') }}
            +e.LI.item._with_margin
                +e.BUTTON.btn.btn._size_md._theme_fill._full(
                    v-on:click="$store.dispatch('closeModal')"
                ) {{ $t('CONTINUE') }}
        +e.item(v-else)
            +e.A(
                v-bind:href='loginLink'
            )
                +e.BUTTON(type="submit").btn._top.btn._size_md._theme_fill._full {{ $t('LOGIN_SIMPLE') }}

</template>
<script>
import { mapGetters } from 'vuex';
import entry from '@/helpers/mixins/entry';

export default {
    mixins: [entry],
    computed: {
        ...mapGetters([
            'isSessionStatus'
        ]),
        sessionText() {
            if (this.isSessionStatus === 'fatal') {
                return 'Ваша сессия истекла. Повторите вход в систему. <b><br/>Номер ошибки #403</br>';
            }
            return 'Вы не запрашивали новую страницу более <b>5 минут.</b>'
                + '<br/>Для продолжения просмотра документа'
                + '<br/>нажмите «Продолжить»';
        }
    }
};
</script>
